/**
 * Lista de DDDs válidos no Brasil.
 */
const VALID_DDDS = new Set([
  '11','12','13','14','15','16','17','18','19',
  '21','22','24',
  '27','28',
  '31','32','33','34','35','37','38',
  '41','42','43','44','45','46',
  '47','48','49',
  '51','53','54','55',
  '61',
  '62','64',
  '63',
  '65','66',
  '67',
  '68',
  '69',
  '71','73','74','75','77',
  '79',
  '81','87',
  '82',
  '83',
  '84',
  '85','88',
  '86','89',
  '91','93','94',
  '92','97',
  '95',
  '96',
  '98','99',
]);

/**
 * Valida um número de celular brasileiro.
 *
 * Aceita strings com ou sem formatação (máscara, parênteses, espaços, traços).
 * Remove DDI 55 se presente.
 *
 * Regras:
 * - Deve ter exatamente 11 dígitos após limpeza (DDD + 9 dígitos)
 * - DDD deve ser válido
 * - O 1º dígito após o DDD deve ser 9
 * - Os 9 dígitos do número não podem ser todos iguais
 * - Os 9 dígitos não podem ser 123456789 ou 987654321
 *
 * @param {string} phone
 * @returns {boolean}
 */
export function isValidBRPhone(phone) {
  if (!phone) return false;

  // Remove tudo que não for dígito
  let digits = phone.replace(/\D/g, '');

  // Remove DDI 55 se presente (12 ou 13 dígitos começando com 55)
  if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) {
    digits = digits.substring(2);
  }

  // Deve ter exatamente 11 dígitos
  if (digits.length !== 11) return false;

  // DDD deve ser válido
  const ddd = digits.substring(0, 2);
  if (!VALID_DDDS.has(ddd)) return false;

  // O 1º dígito após o DDD deve ser 9
  if (digits[2] !== '9') return false;

  // Os 9 dígitos do número (após DDD)
  const number = digits.substring(2);

  // Não pode ser todos iguais
  if (/^(\d)\1{8}$/.test(number)) return false;

  // Não pode ser sequência óbvia
  if (number === '123456789' || number === '987654321') return false;

  return true;
}
